const minChipLabel = 3
const minChipLabelMobile = 2
export {
   minChipLabel,
   minChipLabelMobile
}